import { Component } from '@angular/core';
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'app-filetypes-guide-dialog',
  templateUrl: './filetypes-guide-dialog.component.html',
  styleUrls: ['./filetypes-guide-dialog.component.scss'],
  imports: [MatDialogContent, MatDialogTitle],
})
export class FiletypesGuideDialogComponent {
  constructor(public dialogRef: MatDialogRef<FiletypesGuideDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
